export default {
  enterprise: 'Doanh nghiệp',
  supportTitle: 'Hỗ trợ',
  start: 'Bắt đầu',

  support: {
    technology: 'Công nghệ',
    blog: 'Blog',
    request: 'Liên hệ kinh doanh',
    company: 'Giới thiệu công ty',
  },
};
